import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

// Uncomment or replace with actual SEO component if needed

export const AboutCountryEurope = () => {
  const navigate = useNavigate();

  const EuropeData = {
    title: "Study Abroad Opportunities in Europe",
    mTitle: "Why Study in Europe?",
    desc_1:
      "Europe stands as a global leader in higher education, offering an unparalleled diversity of academic programs and institutions. With cutting-edge research facilities, innovative teaching methods, and strong support for international students, studying in Europe opens doors to global opportunities.",
    desc_2:
      "In Europe, you’ll find not only academic excellence but also a diverse cultural environment, internships, and strong industry ties. It’s more than education—it’s a life experience.",
  };

  const EuropeBenefits = [
    { title: "World-Class Education", number: 550, suffix: "+" },
    { title: "Diverse Academic Programs", number: 100, suffix: "%" },
    { title: "Top-Ranked Universities", number: 300, suffix: "+" },
    { title: "Strong Industry Connections", number: 550, suffix: "+" },
  ];

  const EuropeUniversities = [
  // 🇫🇷 France
  {
    title: "College De Paris",
    country: "France",
    img: "/image/study-abroad/europe/college-de-paris.png",
    link: "#",
  },
  {
    title: "Schiller International University",
    country: "France",
    img: "/image/study-abroad/europe/schiller-international-university.png",
    link: "#",
  },
  {
    title: "Aix Marseille Universite",
    country: "France",
    img: "/image/study-abroad/europe/aix-marseille-universite.jpg",
    link: "#",
  },
  {
    title: "Burgundy School of Business",
    country: "France",
    img: "/image/study-abroad/europe/burgundy-school-of-business.jpg",
    link: "#",
  },
  {
    title: "University of Lyon",
    country: "France",
    img: "/image/study-abroad/europe/university-of-lyon.png",
    link: "#",
  },
  {
    title: "ICN Business School",
    country: "France",
    img: "/image/study-abroad/europe/icn-business-school.png",
    link: "#",
  },
  {
    title: "De Vinci University",
    country: "France",
    img: "/image/study-abroad/europe/de-vinci-university.jpg",
    link: "#",
  },


  // 🇪🇸 Spain
  {
    title: "UCAM",
    country: "Spain",
    img: "/image/study-abroad/europe/ucam.png",
    link: "#",
  },
  {
    title: "Schiller International University",
    country: "Spain",
    img: "/image/study-abroad/europe/schiller-international-university.png",
    link: "#",
  },
  {
    title: "EADA Business School",
    country: "Spain",
    img: "/image/study-abroad/europe/eada-business-school.png",
    link: "#",
  },
  {
    title: "EU Business School",
    country: "Spain",
    img: "/image/study-abroad/europe/eu-business-school.png",
    link: "#",
  },

  // 🇩🇪 Germany
  {
    title: "Schiller International University",
    country: "Germany",
    img: "/image/study-abroad/europe/schiller-international-university.png",
    link: "#",
  },
  {
    title: "Berlin School of Business and Innovation",
    country: "Germany",
    img: "/image/study-abroad/europe/berlin-school-of-business-and-innovation.png",
    link: "#",
  },
  {
    title: "University of Europe for Applied Sciences",
    country: "Germany",
    img: "/image/study-abroad/europe/university-of-europe-for-applied-sciences.png",
    link: "#",
  },
  {
    title: "GISMA University of Applied Sciences",
    country: "Germany",
    img: "/image/study-abroad/europe/gisma-university-of-applied-sciences.png",
    link: "#",
  },
];


  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
        <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {EuropeData.title}
        </h1>

        {/* Carousel Section */}
        <div className="mb-10 mt-10">
          <h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5">
            Top Universities in Europe
          </h3>
          <p className="text-gray-600 mb-6 mt-5">Explore Our Partner Institutions</p>

          <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
          >
            {EuropeUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white mt-10 rounded-lg shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">{univ.title}</h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>
        </div>

        {/* Description Section */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">{EuropeData.mTitle}</h2>
        <p className="text-gray-700 mb-3 leading-relaxed">{EuropeData.desc_1}</p>
        <p className="text-gray-700 leading-relaxed">{EuropeData.desc_2}</p>
        <img
          src="/image/about/about-07/europe.png"
          alt="Study in Europe"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
        
        </section>

      {/* Benefits Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Key Benefits of Studying in Europe</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {EuropeBenefits.map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100">
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryEurope;
